import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  setSgcConfigurationSnackBar,
  closeSgcConfigurationsSnackBar,
  setConfigPageSizeSgcConfigurations,
  setConfigPageSgcConfigurations,
  setConfigSortedSgcConfigurations,
  setConfigFilteredSgcConfigurations,
  setSgcConfigurationsFilters
} from "redux/actions/sgcConfigurations/sgcConfigurationsAction";

export const useTableSgcConfigurationsConfig = () => {
  const dispatch = useDispatch();

  const handleFilter = useCallback((e) => {
    dispatch(setConfigFilteredSgcConfigurations(e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(setConfigSortedSgcConfigurations(e));
  }, []);

  const setSnackBar = useCallback((msg) => {
    dispatch(setSgcConfigurationSnackBar(msg));
  }, []);

  const clearSnackBar = useCallback(() => {
    dispatch(closeSgcConfigurationsSnackBar());
  }, []);

  const handlePage = useCallback((e) => {
    dispatch(setConfigPageSgcConfigurations(e));
  }, []);

  const handlePageSize = useCallback((e) => {
    dispatch(setConfigPageSizeSgcConfigurations(e));
  }, []);

  const handleInputs = useCallback(({ target }) => {
    dispatch(setSgcConfigurationsFilters(target.name, target.value));
  }, []);

  const handleChangeStation = useCallback((e, v) => {
    dispatch(setSgcConfigurationsFilters('station', v ? v : null));
  }, []);

  return {
    setSnackBar, clearSnackBar, handleInputs, handleFilter, handleSort, handlePage, handlePageSize, handleChangeStation
  };
};
